module.exports = __webpack_public_path__ + "media/images/icons/material/stackoverflow-b18301a687ccdfed6e5d2be3001fc33c.svg";